<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    //components
    import ButtonWrapperPrimary from '../../buttons/button-wrapper-primary.svelte';
    import ButtonWrapper from '../../buttons/button-wrapper.svelte';

    import IconAutoplay from '@root/src/components/icons/icon-autoplay.svelte';
    import IconUndo from '@root/src/components/icons/icon-undo.svelte';
    import IconReset from '@root/src/components/icons/icon-reset.svelte';
    import IconX2 from '@root/src/components/icons/icon-x2.svelte';
    import Chip from '../../chips/chip.svelte';
    import { isUndoResetHistory } from '@root/src/store';
    import { chipTotalBet, isAllMaxedOut } from '@root/src/store/chips';
    import ChipPriceInfo from '../../chips/chip-price-info.svelte';

    //exports
    export let allowToPlay: boolean;
    export let allowToSkip: boolean;
    export let balance: string;
    export let autoBetCount: number;
    export let selectedChipAmount: number;
    export let selectedChipIndex: number;
    export let currency: string;
    export let decimalValue;
    export let chipPrice;

    //functions
    const dispatch = createEventDispatcher();

    const startOrSkipGame = () => {
        dispatch(allowToSkip ? 'skip-game' : 'start-game');
    };

    const resetOrUndo = () => {
        dispatch($isUndoResetHistory ? 'reset' : 'undo');
    };
</script>

<div class="flex place-items-center justify-center gap-x-3 desktop:h-32 desktop:gap-x-4">
    <ButtonWrapper class="button-controls-main-wrapper" disabled={$chipTotalBet === 0} on:click={resetOrUndo}>
        {#if $isUndoResetHistory}
            <IconReset />
        {:else}
            <IconUndo />
        {/if}
    </ButtonWrapper>

    <div class="relative flex flex-col">
        <Chip
            class="aspect-square h-12 w-12 text-2xl"
            value={selectedChipAmount}
            index={selectedChipIndex}
            disabled={!allowToPlay && $chipTotalBet !== 0}
            on:click={() => dispatch('toggle-bet-size-chips')}
        />
        <div class="absolute -bottom-5 left-1/2 w-max -translate-x-1/2">
            <ChipPriceInfo
                class="text-xs text-white/50"
                selectedChip={selectedChipAmount}
                {currency}
                {chipPrice}
                decimal={decimalValue}
            />
        </div>
    </div>

    <ButtonWrapperPrimary
        class="group h-20 w-20  hover:cursor-pointer desktop:h-24 desktop:w-24"
        disabled={!allowToPlay && !allowToSkip}
        on:click={startOrSkipGame}
    >
        <div
            class="primary-button-content text-shadow-main-control cstm-position-center font-Roboto
            text-2xl font-bold uppercase text-white desktop:text-[30px]"
        >
            {allowToSkip ? 'skip' : 'play'}
        </div>
    </ButtonWrapperPrimary>
    <ButtonWrapper
        class="button-controls-main-wrapper"
        disabled={!allowToPlay || $chipTotalBet === 0 || $isAllMaxedOut}
        on:click={() => dispatch('multiply-x2')}
    >
        <IconX2 />
    </ButtonWrapper>
    <ButtonWrapper
        disabled={(parseFloat(balance) <= 0 || !allowToPlay) && !autoBetCount}
        active={!!autoBetCount}
        class="button-controls-main-wrapper"
        on:click={() => dispatch('autoplay-modal')}
    >
        {#if autoBetCount}
            <div
                class="cstm-position-center min-w-[22px] rounded bg-white/90 px-1 py-[3px] font-Roboto text-sm font-medium text-black"
            >
                {autoBetCount}
            </div>
        {:else}
            <IconAutoplay />
        {/if}
    </ButtonWrapper>
</div>
